import "./Login.css";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ApplicationsPortal, useSession } from "@descope/react-sdk";

const Applications = () => {
  const { isAuthenticated, isSessionLoading } = useSession();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isSessionLoading && !isAuthenticated) {
      navigate("/login");
    }
  }, [navigate, isAuthenticated, isSessionLoading]);

  return (
    <div className="login-wrapper">
      <h4>Applications Portal</h4>
      {isSessionLoading && <div>Loading...</div>}
      {isAuthenticated && (
        <>
          <div className="applications-portal-widget">
            <ApplicationsPortal
              theme="dark"
              widgetId="applications-portal-widget"
            />
          </div>
          <div className="logout-button">
            <button type="button" onClick={() => navigate("/")}>
              Home
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default Applications;
